/* eslint-disable */
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import TimelapseIcon from '@material-ui/icons/Timelapse';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_TEST_FREQUENCY_SELECT, UI_TEST_NOTES_BLUR, UI_TEST_NOTES_FOCUS, UI_TEST_REQUIREMENTS_SELECT } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * TestResults
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const TestResults = ({ actions, classes, onChange, defaultRequirements, defaultFrequency, defaultNotes, mandatoryFieldError }) => {
  const [requirements, setRequirements] = useState(defaultRequirements || `NO_TESTING_REQUIRED`);
  const [frequency, setFrequency] = useState(defaultFrequency || `1_50M3`);
  const [notes, setNotes] = useState(defaultNotes);
  const [tooMany, setTooMany] = useState(false);
  const testsValues = [
    {
      description: `No Testing required`,
      value: `NO_TESTING_REQUIRED`,
    },
    {
      description: `Standard Cylinder - 1 x 7 day, 2 x 28 day`,
      value: `STANDARD_CYLINDER`,
    },
    {
      description: `Early Age Cylinder - 1 day`,
      value: `EARLY_AGE_CYLINDER_1_DAY`,
    },
    {
      description: `Early Age Cylinder - 3 day`,
      value: `EARLY_AGE_CYLINDER_3_DAY`,
    },
    {
      description: `Early Age Cylinder - 4 day`,
      value: `EARLY_AGE_CYLINDER_4_DAY`,
    },
    {
      description: `Late Age Cylinder - 56 day`,
      value: `LATE_AGE_CYLINDER_56_DAY`,
    },
    {
      description: `Drying Shrinkage`,
      value: `DRYING_SHRINKAGE`,
    },
    {
      description: `Air`,
      value: `AIR`,
    },
    {
      description: `Flexural Strength - 1 x 7 day, 2 x 28 day`,
      value: `FLEXURAL_STRENGTH`,
    },
    {
      description: `Other`,
      value: `OTHER`,
    },
  ];
  const frequencyValues = [
    {
      description: (
        <span>
          1/50m<sup>3</sup>
        </span>
      ),
      value: `1_50M3`,
    },
    {
      description: (
        <span>
          1/100m<sup>3</sup>
        </span>
      ),
      value: `1_100M3`,
    },
    {
      description: (
        <span>
          1/25m<sup>3</sup>
        </span>
      ),
      value: `1_25M3`,
    },
    {
      description: <span>QLD MRTS70 Testing Frequency</span>,
      value: `QLD_MRTS70`,
    },
    {
      description: <span>NSW RMS B80 Testing Frequency</span>,
      value: `NSW_RMS_B80`,
    },
    {
      description: <span>NSW RMS R82 Testing Frequency</span>,
      value: `NSW_RMS_R82`,
    },
    {
      description: <span>NSW RMS R83 Testing Frequency</span>,
      value: `NSW_RMS_R83`,
    },
    {
      description: <span>Test Every Load</span>,
      value: `TEST_EVERY_LOAD`,
    },
    {
      description: `Other`,
      value: `OTHER`,
    },
  ];

  /**
   * Handles requirements selection
   * @param {Object} e event
   * @returns {void} void
   */
  const onRequirementsHandle = (e) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `testRequirementsSelect`,
        },
      },
      type: UI_TEST_REQUIREMENTS_SELECT,
    });
    setRequirements(e.target.value);
    onChange({
      isValid: true,
      selectedRequirements: testsValues.find((el) => el.value === e.target.value),
      selectedFrequency: frequencyValues.find((el) => el.value === frequency),
      selectedNotes: notes,
    });
    e.preventDefault();
    return;
  };

  /**
   *  Handles frequency selection
   * @param {Object} e event
   * @returns {void} void
   */
  const onFrequencyHandle = (e) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `testFrequencySelect`,
        },
      },
      type: UI_TEST_FREQUENCY_SELECT,
    });
    setFrequency(e.target.value);
    onChange({
      isValid: true,
      selectedRequirements: testsValues.find((el) => el.value === requirements),
      selectedFrequency: frequencyValues.find((el) => el.value === e.target.value),
      selectedNotes: notes,
    });
    e.preventDefault();
    return;
  };

  /**
   *  Handles notes update
   * @param {Object} e event
   * @returns {void} void
   */
  const onNotesHandle = (e) => {
    setNotes(e.target.value);
    setTooMany(e.target.value.length > 272);
    onChange({
      isValid: e.target.value.length <= 272,
      selectedRequirements: testsValues.find((el) => el.value === requirements),
      selectedFrequency: frequencyValues.find((el) => el.value === frequency),
      selectedNotes: e.target.value,
    });
    e.preventDefault();
    return;
  };

  /**
   * Used to report to analytics
   * @returns {void} void
   */
  const onBlurHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `testNotesBlur`,
        },
      },
      type: UI_TEST_NOTES_BLUR,
    });
    return;
  };

  /**
   * Used to report to analytics
   * @returns {void} void
   */
  const onFocusHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `testNotesFocus`,
        },
      },
      type: UI_TEST_NOTES_FOCUS,
    });
    return;
  };

  return (
    <FormControl fullWidth className={classes.formControl}>
      <Grid container>
        <Grid item xs={12}>
          <FormControl fullWidth className={classes.marginBottom2unit}>
            <InputLabel id="test-results">Testing Requirements</InputLabel>
            <Select fullWidth value={requirements} onChange={onRequirementsHandle} className={classes.selectEmpty}>
              {testsValues.map((el) => {
                return (
                  <MenuItem value={el.value} key={el.value}>
                    <Tooltip title={el.description} key={el.value}>
                      <Grid container className={classes.flexWrapNowrap} alignItems="center">
                        <Grid item>
                          <OfflinePinIcon className={classes.testIcon} />
                        </Grid>
                        <Grid item className={classes.overflowHidden}>
                          <Grid container>
                            <Grid item xs={12}>
                              <div className={classes.withEllipsis}>{el.description}</div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Tooltip>
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText>Select any testing you need done on your concrete</FormHelperText>
          </FormControl>
        </Grid>
        {requirements !== `NO_TESTING_REQUIRED` && (
          <Grid item xs={12}>
            <FormControl fullWidth className={classes.marginBottom2unit}>
              <InputLabel id="test-results">Testing Frequency</InputLabel>
              <Select fullWidth value={frequency} onChange={onFrequencyHandle}>
                {frequencyValues.map((el) => {
                  return (
                    <MenuItem value={el.value} key={el.value}>
                      <Tooltip title={el.description} key={el.value}>
                        <Grid container className={classes.flexWrapNowrap} alignItems="center">
                          <Grid item>
                            <TimelapseIcon className={classes.testIcon} />
                          </Grid>
                          <Grid item className={classes.overflowHidden}>
                            <div className={classes.withEllipsis}>{el.description}</div>
                          </Grid>
                        </Grid>
                      </Tooltip>
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText>Select the frequency required for the above testing</FormHelperText>
            </FormControl>
          </Grid>
        )}
        {requirements !== `NO_TESTING_REQUIRED` && (
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                error={mandatoryFieldError}
                fullWidth
                size="medium"
                rows="5"
                rowsMax="8"
                onFocus={onFocusHandler}
                onBlur={onBlurHandler}
                multiline
                label="Testing Notes"
                onChange={onNotesHandle}
                placeholder="Type any notes"
                value={notes || ``}
                helperText="Max 272 characters."
                error={tooMany}
              />
            </FormControl>
          </Grid>
        )}
      </Grid>
    </FormControl>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
TestResults.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultRequirements: PropTypes.string,
  defaultFrequency: PropTypes.string,
  defaultNotes: PropTypes.string,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(TestResults);
